define('locatario-controller',['locatario-resource'], function() {

    var app = angular.module('locatario.controller', [
        'locatario.resource'
    ]);

    app.controller('LocatarioControllerIndex', ['$scope', '$rootScope', 'Locatario', function($scope, $rootScope, Locatario) {
        $scope.usuario = usuario;
        console.log(usuario);


        $scope.msgSucess = '';
        $scope.msgError = '';
        $scope.filterLocatario = {};
        $scope.filterLocatario.selectedYear = new Date().getFullYear();
        $scope.filterLocatario.selectedMonth = new Date().getMonth() + 1;
        $scope.contratoCodigo = null;

        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        const con_codigo = urlParams.get('con');
        const mes = urlParams.get('mes');
        $scope.mes = mes;
        $scope.con_codigo = con_codigo;
        var getYears = function() {
            year = new Date().getFullYear() - 10;
            var anos = [];
            for (i = 0; i <= 20; i++) {
                anos.push(year + i);
            }
            $scope.anos = angular.copy(anos);
        }
        getYears();

        $scope.$mes = [{
                mes: 1,
                nome: 'Janeiro'
            },
            {
                mes: 2,
                nome: 'Fevereiro'
            },
            {
                mes: 3,
                nome: 'Março'
            },
            {
                mes: 4,
                nome: 'Abril'
            },
            {
                mes: 5,
                nome: 'Maio'
            },
            {
                mes: 6,
                nome: 'Junho'
            },
            {
                mes: 7,
                nome: 'Julho'
            },
            {
                mes: 8,
                nome: 'Agosto'
            },
            {
                mes: 9,
                nome: 'Setembro'
            },
            {
                mes: 10,
                nome: 'Outubro'
            },
            {
                mes: 11,
                nome: 'Novembro'
            },
            {
                mes: 12,
                nome: 'Dezembro'
            },
        ];


        $scope.applyFilter = function() {
            Locatario.applyFilter($scope.filterLocatario).then(function(r){
                angular.extend($scope, r);
            });
        };

        $scope.observacao_so_boleto = "Prezado, Gostaria de um boleto atualizado do mês "+mes+" para pagamento. Obrigado ";

        $scope.solicitarBoletoAtualizado = function(){
            var solicitacaoBoleto = {
                usuario: $scope.usuario,
                observacao: $scope.observacao_so_boleto,
                con_codigo: $scope.con_codigo,
                mes: $scope.mes

            }
            Locatario.saveSolicitacaoBoleto(solicitacaoBoleto).then(function(r){
                alert('Solicitação enviada com sucesso !');
                window.location.href = '/areacliente';
            }).catch(function (err) {
                console.error(err);
            });

        };

    }]);
});

